import VuseCardMiniWidget from './CardMiniWidget'
import VuseActionCardWidget from './ActionCardWidget'
import VuseUserProfileWidget from './UserProfileWidget'

export default {
  VuseCardMiniWidget,
  VuseActionCardWidget,
  VuseUserProfileWidget
}
